import { LazyQueryExecFunction } from '@apollo/client';
import { configureAndInitializeAmplify } from '@modules/authentication/utils/configureAndInitializeAmplify';
import { Exact, IsDomainSsoQuery } from 'generated/graphql';

interface configureAmplifyProps {
  verifyDomainSso: LazyQueryExecFunction<
    IsDomainSsoQuery,
    Exact<{
      domain: string;
      slug?: string | undefined;
    }>
  >;
  email: string;
  tenantSlug?: string;
}
export const configureAmplify = async ({
  verifyDomainSso,
  email,
  tenantSlug,
}: configureAmplifyProps) => {
  try {
    const domain = email.split('@')[1];
    const domainSsoResponse = await verifyDomainSso({
      variables: {
        domain,
        slug: tenantSlug,
      },
    });
    configureAndInitializeAmplify(domainSsoResponse.data?.isDomainSso?.isSaml);
  } catch {
    configureAndInitializeAmplify(false);
  }
};
